import { supabase } from '@fd/supabase/index';
import { Session } from '@supabase/supabase-js';
import { useState, useEffect } from 'react';
import { SessionContext } from './SessionContext';
import { usePostHog } from 'posthog-js/react';

type Props = { children: React.ReactNode };
export const SessionProvider = ({ children }: Props) => {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const posthog = usePostHog();

  useEffect(() => {
    const authStateListener = supabase.auth.onAuthStateChange(
      async (_, session) => {
        setSession(session);
        setIsLoading(false);
      }
    );

    return () => {
      authStateListener.data.subscription.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (session) {
      posthog.identify(session.user.id, {
        email: session.user.email,
      });
    }
  }, [posthog, session]);

  return (
    <SessionContext.Provider value={{ session }}>
      {isLoading ? <></> : children}
    </SessionContext.Provider>
  );
};
